var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flames",style:({ 'vertical-align': _vm.align ? 'text-top' : 'baseline' }),attrs:{"title":_vm.title}},[_c('div',{staticClass:"flames-content",class:_vm.flamesContentClass,style:(_vm.flamesContentStyle)})])}
var staticRenderFns = []

export { render, staticRenderFns }